import { ClientDTO } from "../DTO/clientDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateClientRequest extends BasicRequest{
    
    public client! : ClientDTO

    constructor(){
        super();
    }
}